import React, { useEffect, useState } from "react";
import { ThirdWorkTreeAPI } from "../services/api";

interface Props {
  workGroupNo: number | null;
}

interface WorkGroupDetails {
  workGroupNo: number;

  workGroup?: string;
  trackingActivity?: string;
  trackBy?: string;

  netCost?: number;

  unit?: string;
  quantity?: number;

  subContractor?: string;
  subContractValue?: number;
  subContractRate?: number;

  client?: string;
  clientValue?: number;
  clientRate?: number;

  startDate?: string;
  endDate?: string;

  duration?: number;

  workGroupDesc?: string;
}

const rowStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "45% 55%",
  borderBottom: "1px solid #e5e7eb",
  minHeight: 26,
};

const WorkGroupDetailsPanel: React.FC<Props> = ({
  workGroupNo,
}) => {
  const [data, setData] =
    useState<WorkGroupDetails | null>(null);

  useEffect(() => {
    if (!workGroupNo) {
      setData(null);
      return;
    }

    ThirdWorkTreeAPI.getWorkGroupDetails(workGroupNo)
      .then(setData)
      .catch(console.error);
  }, [workGroupNo]);

  if (!workGroupNo) {
    return (
      <div className="p-3 text-gray-500">
        Select a Work Group
      </div>
    );
  }

  if (!data) {
    return (
      <div className="p-3">
        Loading...
      </div>
    );
  }

  return (
    <div className="h-full overflow-auto bg-white text-sm">

      {/* Definition */}
      <div className="bg-gray-100 px-2 py-1 font-semibold border-b">
        Definition
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Work Group</div>
        <div className="px-2 py-1 font-semibold">
          {data.workGroup}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Tracking Activity</div>
        <div className="px-2 py-1">
          {data.trackingActivity}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Track By</div>
        <div className="px-2 py-1">
          {data.trackBy}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Description</div>
        <div className="px-2 py-1">
          {data.workGroupDesc}
        </div>
      </div>

      {/* Measurements */}
      <div className="bg-gray-100 px-2 py-1 font-semibold border-b mt-2">
        Measurements and Rates
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Net Cost</div>
        <div className="px-2 py-1">
          {data.netCost}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Unit</div>
        <div className="px-2 py-1">
          {data.unit}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Quantity</div>
        <div className="px-2 py-1">
          {data.quantity}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Sub Contractor</div>
        <div className="px-2 py-1">
          {data.subContractor}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Sub Contract Value</div>
        <div className="px-2 py-1">
          {data.subContractValue}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Sub Contract Rate</div>
        <div className="px-2 py-1">
          {data.subContractRate}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Client</div>
        <div className="px-2 py-1">
          {data.client}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Client Value</div>
        <div className="px-2 py-1">
          {data.clientValue}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Client Rate</div>
        <div className="px-2 py-1">
          {data.clientRate}
        </div>
      </div>

      {/* Scheduling */}
      <div className="bg-gray-100 px-2 py-1 font-semibold border-b mt-2">
        Scheduling and Tracking
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Start Date</div>
        <div className="px-2 py-1">
          {data.startDate
            ? new Date(data.startDate).toLocaleDateString("en-GB")
            : ""}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">End Date</div>
        <div className="px-2 py-1">
          {data.endDate
            ? new Date(data.endDate).toLocaleDateString("en-GB")
            : ""}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Duration</div>
        <div className="px-2 py-1">
          {data.duration}
        </div>
      </div>

    </div>
  );
};

export default WorkGroupDetailsPanel;